import React from 'react';
import { TTableBlockData } from '../types';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';

import { parseWithoutNonBreakingSpaces } from '../services/parseWithoutNonBreakingSpaces';
import { HighlightSelectionHint, TTableHighlightBlockData } from '../../Highlight/types';
import { withHighlightAsText } from '../../Highlight/services/withHighlightAsText';
import { findTableFragmentPositionInTable } from '../services/findTableFragmentPositionInTable';

export const renderTable = ({ content, withHeadings }: TTableBlockData, highlightData?: TTableHighlightBlockData) => {
  const { content: highlightContent } = highlightData || {};
  const highlightContentPosition = highlightContent && findTableFragmentPositionInTable(content, highlightContent);

  const rows = content.map((row, rowIndex) => {
    const TagName = withHeadings && rowIndex === 0 ? 'th' : 'td';
    return (
      <tr
        key={rowIndex /* eslint-disable-line react/no-array-index-key */}
        {...getHighlightSelectionTipProps(HighlightSelectionHint.TableRow)}
      >
        {Array.isArray(row) &&
          row.map((columnValue, columnIndex) => {
            const columnHighlight =
              highlightContentPosition &&
              highlightContent?.[rowIndex - highlightContentPosition[0]]?.[columnIndex - highlightContentPosition[1]];
            return (
              <TagName
                key={columnIndex /* eslint-disable-line react/no-array-index-key */}
                className="article__table__data"
                {...getHighlightSelectionTipProps(HighlightSelectionHint.TableColumn)}
              >
                {parseWithoutNonBreakingSpaces(withHighlightAsText(columnValue, columnHighlight))}
              </TagName>
            );
          })}
      </tr>
    );
  });

  return (
    <table className="article__table" {...getHighlightSelectionTipProps(HighlightSelectionHint.Table)}>
      {withHeadings && <thead>{rows[0]}</thead>}
      <tbody>{withHeadings ? rows.slice(1) : rows}</tbody>
    </table>
  );
};
